export default "__VITE_ASSET__DwyQoNv2__"